import "material-dynamic-colors";
import "./cdn/beer.css";
import "./cdn/beer";
import "./app.css";
import "./home";
import "./dynamicColors";
import "./gmail";
import "./materialDesign3";
import "./musicPlayer";
import "./netflix";
import "./reddit";
import "./test";
import "./uber";
import "./youtube";
import utils from "./shared/utils";

utils.waitForInstall();
